module.exports = __webpack_public_path__ + "hk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/hk.svg
// module id = 592
// module chunks = 0